export type BookingType = "office" | "remote" | "off";

export type Booking = {
  id: number;

  date: string;
  collaboratorId: number;
  deskId?: number;

  status: "ok" | "conflict";
  type: BookingType;
};

export type Shifts = {
  [collaboratorId: string]: {
    /**
     * @deprecated Prefer using booking
     */
    officePresence: OfficePresence;
    bookings: { [date: string]: Booking };
  };
};

export type OfficePresence = {
  [date: string]: {
    seatId?: number;
  };
};

export const bookingToShifts = (bookings: Booking[]) => {
  return (bookings || []).reduce((shifts: Shifts, curr) => {
    if (!shifts[curr.collaboratorId]) {
      shifts[curr.collaboratorId] = { officePresence: {}, bookings: {} };
    }

    shifts[curr.collaboratorId].officePresence[curr.date] = { seatId: curr.deskId };
    shifts[curr.collaboratorId].bookings[curr.date] = curr;

    return shifts;
  }, {});
};
